import { CommonDT, PageQueryParams, RestResponse } from "./CommonDT";
import { _get, _post, _req } from "../../request";
import { termsDataType } from "./term-api";
import { coactsDataType } from "./coast-api";
import { UserDataType } from "../sys/user-api";

export type CyhersDataType = CommonDT & {
  cypherIncId: number;
  cypherKey: string;
  cypherUsedTimes: number;
  cypherUsedData: string;
  // userFingerprint: string;
  postTitle: string;
  postCover: string;
  postSourceUrl: string;
  postSourceType: string;
  fkUserId: string;
  fkPostId: string;
  fkTermId: string;
};

/**
 * ==========================================================
 * ========================公共接口===========================
 * ==========================================================
 */
const get = async (id: any): Promise<RestResponse> => {
  return await _get("/cnt/cyphers/get/", id);
};

const page = async (
  params: {},
  data: PageQueryParams
): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/page", "POST", params, data);
};

const saveBatch = async (dataList: CyhersDataType): Promise<RestResponse> => {
  return await _post("/cnt/cyphers/saveBatch", dataList);
};

const alterBatch = async (dataList: CyhersDataType): Promise<RestResponse> => {
  return await _post("/cnt/cyphers/alterBatch", dataList);
};

const removeBatch = async (idList: string[]): Promise<RestResponse> => {
  return await _post("/cnt/cyphers/removeBatch", idList);
};

/**
 * ==========================================================
 * ========================特有接口===========================
 * ==========================================================
 */
const other = async (params: {}, body: {}): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/other", "POST", params, body);
};
const parseCypher = async (
  params: { userId: string; cypherKey: string },
  data: {}
): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/parseCypher", "GET", params, data);
};
const helpCypher = async (params: {
  userId: string;
  browserFinger: string;
  cypherKey: string;
}): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/helpCypher", "GET", params);
};
const shareCypher = async (
  params: {},
  cypher: { fkUserId: string; fkPostId: string }
): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/shareCypher", "POST", params, cypher);
};
const crackCypher = async (params: {
  userId: string;
  postId: string;
}): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/crackCypher", "GET", params);
};
const mineCypher = async (params: {
  userId: string;
}): Promise<RestResponse> => {
  return await _req("/cnt/cyphers/mineCypher", "GET", params);
};

const CypherApi = {
  get,
  page,
  saveBatch,
  alterBatch,
  removeBatch,
  other,
  parseCypher,
  helpCypher,
  shareCypher,
  crackCypher,
  mineCypher,
};

export default CypherApi;
